<template>
    <div>
        <group-page-header title="Group Posts">
            <span slot="additionalButtons">
                <vue-search-input
                        class="hidden-md hidden-lg"
                        @search="startSearch"
                        @cancel="cancelSearch"
                        :min-letters-count="2"
                        :max-width="170"
                        collapsable
                ></vue-search-input>
            </span>
        </group-page-header>
        <stories-list
                :stories-list-endpoint="storiesListEndpoint"
                :allow-filter="false"
                :allow-create="false"
                :track-query-in-url="false"
                :search-field-classes="['hidden-xs','hidden-sm']"
                use-query-as-back-href
                ref="storiesList"
        >
            <div class="row margin-15-top" slot="emptyMessage">
                <div class="col-sm-12">
                    <div class="alert alert-info">
                        There has been nothing added to this Group's Stories yet
                    </div>
                </div>
            </div>
            <div class="row margin-15-top" slot="emptyMessageSearch">
                <div class="col-sm-12">
                    <div class="alert alert-info">
                        No Stories were found that match your query
                    </div>
                </div>
            </div>
        </stories-list>
    </div>
</template>

<script>
    import _ from "lodash";
    import {mapGetters} from "vuex";
    import Vue from "vue";
    import GroupResource from "../groups/group_resource";
    import StoriesList from "../stories/story_list_directive/StoriesList";
    import GroupPageHeader from "./common/GroupPageHeader";

    export default {
        name: "GroupPagePosts",
        components: {GroupPageHeader, StoriesList},
        computed: {
            ...mapGetters('groupPage', {group: 'group'}),
            storiesListEndpoint() {
                const $http = Vue.getAngularModule('$http');
                return _.partial(GroupResource($http).get_group_posts, this.group.id);
            }
        },
        methods: {
            startSearch(q) {
                this.$refs.storiesList.startSearch(q);
            },
            cancelSearch() {
                this.$refs.storiesList.cancelSearch();
            },
        }
    };
</script>

<style scoped lang="scss">
  @import "commonStyle";
</style>